import * as Yup from "yup";
import { getPatchOperations } from "../../../../util/form";

export const personBeskikkelserForm = (
  beskikkelseId: string,
  personId: string,
): FormConfig<PersonBeskikkelseDTO> => {
  return {
    title: "beskikkelse",
    validationSchema: Yup.object({
      aarsag: Yup.string(),
    }),
    form: [
      {
        component: "textarea",
        id: "aarsag",
        label: "Årsag",
        initialValue: "",
      },
    ],
    get: `person/${personId}/beskikkelser/${beskikkelseId}`,
    patch(values: PersonBeskikkelseDTO) {
      const { aarsag } = values;
      return {
        query: `person/${personId}/beskikkelser/${beskikkelseId}`,
        body: JSON.stringify(getPatchOperations({ aarsag })),
      };
    },
  };
};
